
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-088ec2e2&scoped=true!../css/formAdicionarGlosa.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormAdicionarGlosa.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-088ec2e2!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormAdicionarGlosa.vue"),
  /* scopeId */
  "data-v-088ec2e2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/glosa/form/FormAdicionarGlosa.vue
// module id = 888
// module chunks = 1